import { create } from 'zustand';

import { MEDIA_PAGE_SIZE, type MediaOrderKey, type MediaType } from './media';

interface MediaQueryState {
  search: string;
  type: 'all' | MediaType;
  order: MediaOrderKey;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setType: (type: 'all' | MediaType) => void;
  setOrder: (order: MediaOrderKey) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<MediaQueryState, 'search' | 'type' | 'order' | 'page' | 'pageSize'> = {
  search: '',
  type: 'all',
  order: 'newest',
  page: 1,
  pageSize: MEDIA_PAGE_SIZE,
};

export const useMediaStore = create<MediaQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setType: (type) => set({ type, page: 1 }),
  setOrder: (order) => set({ order, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
